import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Addpromo() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [title, settitle] = useState("");
  const [price, setprice] = useState(null);
  const [image, setImage] = useState("");
  const [description, setdescription] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [titleModal, settitleModal] = useState("");
  const sizeImage = 1000000;

  const addCafe = async () => {
    const data = new FormData();
    data.append("title", title);
    data.append("price", price);
    data.append("image", image);
    data.append("description", description);

    if (image.size > sizeImage) {
      settitleModal("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (
      title !== "" &&
      price !== null &&
      image !== "" &&
      description !== ""
    ) {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/promo", data);
      setLoading(false);
      settitleModal("Success Add Promo");
      setModalShow(true);
    } else {
      settitleModal("Isi Semua Form");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/promo/");
  };

  return (
    <div className="container-fluid">
      {loading ? (
        <Loading />
      ) : (
        <div className="row">
          <div className="col-12">
            <div className="wrapper-add-user">
              <div className="wrapper-edit-image">
                <div className="header-edit-image">
                  <h5 className="m-0">Add Promo</h5>
                </div>
                <div className="data-user">
                  <div className="wrapper-data">
                    <label>
                      Ttile <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      onChange={(e) => settitle(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Price <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="price"
                      onChange={(e) => setprice(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Image (Max 1MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {image && image.size > sizeImage
                          ? "Image size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="file"
                      name="image"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      style={{
                        height: "20vh",
                        outline: "none",
                        borderRadius: "5px",
                      }}
                      type="text"
                      name="description"
                      onChange={(e) => setdescription(e.target.value)}
                    ></textarea>
                  </div>
                  <button onClick={() => addCafe()}>Create Promo</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={titleModal}
        nextButton={
          titleModal !== "Isi Semua Form" &&
          titleModal !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addpromo;
